import React from "react";
import BloquedUsers from "../../views/adminView/bloquedUsers";

export default function BloquedUsersPage() {
    return <BloquedUsers />
}